import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Workflowy is to TODO as git is to svn",
  "description": "",
  "published": "2010-11-23T00:00:00.000Z",
  "redirect_from": ["/blog/workflowy-is-to-todo-as-git-is-to-svn/swizec/1494"],
  "categories": "Evernote, Git, IOS (Apple), Macintosh, Time management, Uncategorized, workflowy",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It is no secret that I am generally a very fuzzy scattered person.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:Interactive_whiteboard2.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/11/300px-Interactive_whiteboard2.jpg",
              "alt": "A student using an Interactive Whiteboard",
              "title": "A student using an Interactive Whiteboard"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:Interactive_whiteboard2.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`It is also no secret that I am trying to work on that at least to a certain extent.`}</p>
    <p>{`Ok so I've tried numerous things to get myself organised; everything from entering TODO's into `}<a parentName="p" {...{
        "href": "http://www.evernote.com",
        "title": "Evernote"
      }}>{`Evernote`}</a>{`, to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Macintosh",
        "title": "Macintosh"
      }}>{`Mac`}</a>{` widget thingies and the pretty awesome `}<a parentName="p" {...{
        "href": "http://culturedcode.com/things/"
      }}>{`Things`}</a>{` app and just plain writing stuff on a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Whiteboard",
        "title": "Whiteboard"
      }}>{`whiteboard`}</a>{` and erasing it when it's done.`}</p>
    <p>{`So far all of the solutions proved to have their advantages and disadvantages.`}</p>
    <p>{`Evernote syncs on all devices, but is pretty stiff and clearly meant for other things.`}</p>
    <p>{`Widgets are too hidden and I forget about them.`}</p>
    <p>{`Things was nice and very shiny and, dare I say it, quite a bit useful. But over time it became simply annoying. Only on one computer, always pestering me about "OMG you forgot to do this! OMG it's already 100 days overdue! OHMYFUCKINGGODMAN!!!"`}</p>
    <p>{`Yeah, fuck that shit.`}</p>
    <p>{`Out of all the things the whiteboard seemed the most efficient way of doing things. There it is, always on the wall, every task I haven't completed staring me in the face every time I turn around. Not judging, just gently reminding me that hey, I might as well do it if I ever want to see a clean whiteboard again.`}</p>
    <p>{`But hey, that's not very portable either. There's one at the office and another one in my bedroom. Any task that isn't strictly tied to a one room radius of the whiteboard will never get executed because I'll forget about it on my way out the door ...`}</p>
    <p>{`And then along comes `}<a parentName="p" {...{
        "href": "http://workflowy.com"
      }}>{`Workflowy`}</a>{` with a small post on HackerNews saying "Hey, we're from YC2k9 and we've launched. We help you organize your brain" (this was a week or two ago)`}</p>
    <p>{`Then I watched their video. And I drooled!`}</p>
    <p>{`Workflowy was exactly the app I've been looking for. It was love at first sight.`}</p>
    <p>{`Basically what they give you is an infinite online whiteboard that you can take anywhere.`}</p>
    <p>{`Awesome! Brilliant! Doesn't even begin to describe it.`}</p>
    <p>{`Everything you write on Workflowy is a nested bulletpoint list. This is where it gets mindblowingly awesomer than an old fashioned `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Time_management",
        "title": "Time management"
      }}>{`TODO list`}</a>{`.`}</p>
    <p>{`The old way was writing a list of items you have to do in a somewhat hierarchical order. God forbid you have to switch contexts ten times a day and end up with a big mess.`}</p>
    <p>{`Workflowy is a bit more like git. You have branches running in parallel. The way I use it is to have the top level represent a list of contexts I work on and then on the second level I just jot down the workflow. It's not exactly a TODO list, it's more of a "OK here's how I'm gonna tackle this problem".`}</p>
    <p>{`Because of how my brain works it's really quite a bit less organized than a TODO list. But it still helps me not fuck things up by forgetting them.`}</p>
    <p>{`Like, you could do something like this:`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/11/Screen-shot-2010-11-24-at-12.33.17-AM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/11/Screen-shot-2010-11-24-at-12.33.17-AM.png",
          "alt": null,
          "title": "Workflowy example"
        }}></img></a></p>
    <p>{`And you're set!`}</p>
    <p>{`Really, I urge everyone who doesn't like their organisation tool to force them into boxes and limit the way they work to try out Workflowy.`}</p>
    <p>{`Actually the only thing I dislike right now is that it doesn't work on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mobile_device",
        "title": "Mobile device"
      }}>{`mobile devices`}</a>{`, not even tablets. Just gives you a warning that hey, you're a smartphone, fuck you and come back later when we do support you.`}</p>
    <p>{`That's a bit lame especially considering Mobile Safari is plenty strong enough to support everything you need. Maybe it's got something to do with their monetization strategy; get us hooked on the web version then sell the `}<a parentName="p" {...{
        "href": "http://developer.apple.com/iphone",
        "title": "IOS (Apple)"
      }}>{`iOS`}</a>{` app for shitloads of money ... (hopefully this loving post is enough to get them to give me free stuff :P)`}</p>
    <p><em parentName="p">{`Update: apparently a MVP of mobile support is due to come out in a few days.`}</em></p>
    <p>{`Anyway, yeah, try them out. They're cool.`}</p>
    <p>{`Oh and as far as the UI goes. I love it because it's Spartan and no-nonsense and lets me do everything via simple to remember keyboard shortcuts. Please don't add any more features. kthxbai`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2010/11/04/workflow/"
        }}>{`Turn Your Entire Life Into A List With Workflowy`}</a>{` (techcrunch.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.workflowy.com/"
        }}>{`WorkFlowy - Make Lists. Not War.`}</a>{` (workflowy.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.downloadsquad.com/2010/11/11/workflowy-is-a-lightweight-outliner-endorsed-by-matt-cutts/?icid=zemanta"
        }}>{`WorkFlowy is a lightweight outliner endorsed by Matt Cutts`}</a>{` (downloadsquad.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.rev2.org/2010/11/05/workflowy-your-life-but-as-a-list/"
        }}>{`Workflowy: Your Life, but as a List`}</a>{` (rev2.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=26741015-ee45-4036-92b6-b648be498ad4",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      